import * as dateFns from 'date-fns';

export const CON_TARGET_DATA = Object.freeze({
    1: {
        18: {
            1: {
                calories: 2250,
                protein: 65,
                lipid: [50, 75],
                carbohydrate: 323.5,
                sodium_content: 7.5,
                potassium: 2500,
                dietary_fiber: 20,
                iron: 7.0,
            },
            2: {
                calories: 2600,
                protein: 65,
                lipid: [58, 87],
                carbohydrate: 373.8,
                sodium_content: 7.5,
                potassium: 2500,
                dietary_fiber: 20,
                iron: 7.0,
            },
            3: {
                calories: 3000,
                protein: 65,
                lipid: [67, 100],
                carbohydrate: 431.3,
                sodium_content: 7.5,
                potassium: 2500,
                dietary_fiber: 20,
                iron: 7.0,
            },
        },
        30: {
            1: {
                calories: 2350,
                protein: 65,
                lipid: [52, 78],
                carbohydrate: 337.9,
                sodium_content: 7.5,
                potassium: 2500,
                dietary_fiber: 22,
                iron: 7.5,
            },
            2: {
                calories: 2750,
                protein: 65,
                lipid: [61, 92],
                carbohydrate: 395.4,
                sodium_content: 7.5,
                potassium: 2500,
                dietary_fiber: 22,
                iron: 7.5,
            },
            3: {
                calories: 3150,
                protein: 65,
                lipid: [70, 105],
                carbohydrate: 452.9,
                sodium_content: 7.5,
                potassium: 2500,
                dietary_fiber: 22,
                iron: 7.5,
            },
        },
        50: {
            1: {
                calories: 2250,
                protein: 65,
                lipid: [50, 75],
                carbohydrate: 323.5,
                sodium_content: 7.5,
                potassium: 2500,
                dietary_fiber: 22,
                iron: 7.0,
            },
            2: {
                calories: 2650,
                protein: 65,
                lipid: [59, 88],
                carbohydrate: 381.0,
                sodium_content: 7.5,
                potassium: 2500,
                dietary_fiber: 22,
                iron: 7.0,
            },
            3: {
                calories: 3000,
                protein: 65,
                lipid: [67, 100],
                carbohydrate: 431.3,
                sodium_content: 7.5,
                potassium: 2500,
                dietary_fiber: 22,
                iron: 7.0,
            },
        },
        65: {
            1: {
                calories: 2100,
                protein: 60,
                lipid: [47, 70],
                carbohydrate: 301.9,
                sodium_content: 7.5,
                potassium: 2500,
                dietary_fiber: 21,
                iron: 7.0,
            },
            2: {
                calories: 2350,
                protein: 60,
                lipid: [52, 78],
                carbohydrate: 337.9,
                sodium_content: 7.5,
                potassium: 2500,
                dietary_fiber: 21,
                iron: 7.0,
            },
            3: {
                calories: 2650,
                protein: 60,
                lipid: [59, 88],
                carbohydrate: 381.0,
                sodium_content: 7.5,
                potassium: 2500,
                dietary_fiber: 21,
                iron: 7.0,
            },
        },
    },
    2: {
        18: {
            1: {
                calories: 1700,
                protein: 50,
                lipid: [38, 57],
                carbohydrate: 244.4,
                sodium_content: 6.5,
                potassium: 2000,
                dietary_fiber: 18,
                iron: 10.0,
            },
            2: {
                calories: 1950,
                protein: 50,
                lipid: [43, 65],
                carbohydrate: 280.4,
                sodium_content: 6.5,
                potassium: 2000,
                dietary_fiber: 18,
                iron: 10.0,
            },
            3: {
                calories: 2250,
                protein: 50,
                lipid: [50, 75],
                carbohydrate: 323.5,
                sodium_content: 6.5,
                potassium: 2000,
                dietary_fiber: 18,
                iron: 10.0,
            },
        },
        30: {
            1: {
                calories: 1750,
                protein: 50,
                lipid: [39, 58],
                carbohydrate: 251.6,
                sodium_content: 6.5,
                potassium: 2000,
                dietary_fiber: 18,
                iron: 10.5,
            },
            2: {
                calories: 2050,
                protein: 50,
                lipid: [46, 68],
                carbohydrate: 294.7,
                sodium_content: 6.5,
                potassium: 2000,
                dietary_fiber: 18,
                iron: 10.5,
            },
            3: {
                calories: 2350,
                protein: 50,
                lipid: [52, 78],
                carbohydrate: 337.9,
                sodium_content: 6.5,
                potassium: 2000,
                dietary_fiber: 18,
                iron: 10.5,
            },
        },
        50: {
            1: {
                calories: 1700,
                protein: 50,
                lipid: [38, 57],
                carbohydrate: 244.4,
                sodium_content: 6.5,
                potassium: 2000,
                dietary_fiber: 18,
                iron: 10.5,
            },
            2: {
                calories: 1950,
                protein: 50,
                lipid: [43, 65],
                carbohydrate: 280.4,
                sodium_content: 6.5,
                potassium: 2000,
                dietary_fiber: 18,
                iron: 10.5,
            },
            3: {
                calories: 2250,
                protein: 50,
                lipid: [50, 75],
                carbohydrate: 323.5,
                sodium_content: 6.5,
                potassium: 2000,
                dietary_fiber: 18,
                iron: 10.5,
            },
        },
        65: {
            1: {
                calories: 1650,
                protein: 50,
                lipid: [37, 55],
                carbohydrate: 237.2,
                sodium_content: 6.5,
                potassium: 2000,
                dietary_fiber: 18,
                iron: 6.0,
            },
            2: {
                calories: 1850,
                protein: 50,
                lipid: [41, 62],
                carbohydrate: 266.0,
                sodium_content: 6.5,
                potassium: 2000,
                dietary_fiber: 18,
                iron: 6.0,
            },
            3: {
                calories: 2050,
                protein: 50,
                lipid: [46, 68],
                carbohydrate: 294.7,
                sodium_content: 6.5,
                potassium: 2000,
                dietary_fiber: 18,
                iron: 6.0,
            },
        },
    },
});

/**
 * HEX値のカラーを比率に合わせて暗くする
 * @param {string} color 
 * @param {number} ratio 
 * @returns
 */
export const hexColorToDarken = (color, ratio) => {
    const regex = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;
    if (regex.test(color)) {
        let red = 0;
        let green = 0;
        let blue = 0;

        if (color.length > 4) {
            const rgb = color.match(/[0-9a-fA-F]{2}/g);
            red = parseInt(rgb[0], 16);
            green = parseInt(rgb[1], 16);
            blue = parseInt(rgb[2], 16);
        } else {
            const rgb = color.match(/[0-9a-fA-F]/g);
            red = parseInt(rgb[0] + rgb[0], 16);
            green = parseInt(rgb[1] + rgb[1], 16);
            blue = parseInt(rgb[2] + rgb[2], 16);
        }
        red = red - Math.round(red * ratio);
        red = red < 0 ? 0 : red;
        green = green - Math.round(green * ratio);
        green = green < 0 ? 0 : green;
        blue = blue - Math.round(blue * ratio);
        blue = blue < 0 ? 0 : blue;
        return '#' + ('0' + red.toString(16)).slice(-2)
            + ('0' + green.toString(16)).slice(-2)
            + ('0' + blue.toString(16)).slice(-2);
    }
    return '#000000';
};

/**
 * HEX値のカラーを比率に合わせて明るくする
 * @param {string} color 
 * @param {number} ratio 
 * @returns 
 */
export const hexColorToBright = (color, ratio) => {
    const regex = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;
    if (regex.test(color)) {
        let red = 0;
        let green = 0;
        let blue = 0;

        if (color.length > 4) {
            const rgb = color.match(/[0-9a-fA-F]{2}/g);
            red = parseInt(rgb[0], 16);
            green = parseInt(rgb[1], 16);
            blue = parseInt(rgb[2], 16);
        } else {
            const rgb = color.match(/[0-9a-fA-F]/g);
            red = parseInt(rgb[0] + rgb[0], 16);
            green = parseInt(rgb[1] + rgb[1], 16);
            blue = parseInt(rgb[2] + rgb[2], 16);
        }
        red = red + Math.round((255 - red) * ratio);
        red = red > 255 ? 255 : red;
        green = green + Math.round((255 - green) * ratio);
        green = green > 255 ? 255 : green;
        blue = blue + Math.round((255 - blue) * ratio);
        blue = blue > 255 ? 255 : blue;
        return '#' + ('0' + red.toString(16)).slice(-2)
            + ('0' + green.toString(16)).slice(-2)
            + ('0' + blue.toString(16)).slice(-2);
    }
    return '#ffffff';
};

/**
 * 提供時間帯と時間帯区分を算出する
 * @param {string} from_1
 * @param {string} to_1
 * @param {string} from_2
 * @param {string} to_2
 * @param {string} from_3
 * @param {string} to_3
 * @param {string} from_4
 * @param {string} to_4
 * @returns
 */
export const getTimeSectionAndMenuKind = (
    from_1,
    to_1,
    from_2,
    to_2,
    from_3,
    to_3,
    from_4,
    to_4
) => {
    // 初期値等
    const today = new Date();
    const yesterday = dateFns.subDays(today, 1);
    let provide_date = dateFns.format(today, 'yyyyMMdd');
    let time_section = '0';
    // 現在時刻が指定時間帯内の区分、又は、時間帯内ではない場合は次に来る時間帯区分をセットする
    // 当日時間帯区分4
    if (
        from_4 &&
        from_4 !== '' &&
        to_4 &&
        to_4 !== ''
    ) {
        // from, to の日付データ
        const from = dateFns.parse(
            from_4 + ':00',
            'HH:mm:ss',
            today
        );
        let to = dateFns.parse(
            to_4 + ':00',
            'HH:mm:ss',
            today
        );
        // to が from より前の場合、翌日にする
        if (dateFns.isBefore(to, from)) {
            to = dateFns.addDays(to, 1);
        }
        // today < to
        if (dateFns.isBefore(today, to)) {
            time_section = '4';
        }
    }
    // 当日時間帯区分3
    if (
        from_3 &&
        from_3 !== '' &&
        to_3 &&
        to_3 !== ''
    ) {
        // from, to の日付データ
        const from = dateFns.parse(
            from_3 + ':00',
            'HH:mm:ss',
            today
        );
        let to = dateFns.parse(
            to_3 + ':00',
            'HH:mm:ss',
            today
        );
        // to が from より前の場合、翌日にする
        if (dateFns.isBefore(to, from)) {
            to = dateFns.addDays(to, 1);
        }
        // today < to
        if (dateFns.isBefore(today, to)) {
            time_section = '3';
        }
    }
    // 当日時間帯区分2
    if (
        from_2 &&
        from_2 !== '' &&
        to_2 &&
        to_2 !== ''
    ) {
        // from, to の日付データ
        const from = dateFns.parse(
            from_2 + ':00',
            'HH:mm:ss',
            today
        );
        let to = dateFns.parse(
            to_2 + ':00',
            'HH:mm:ss',
            today
        );
        // to が from より前の場合、翌日にする
        if (dateFns.isBefore(to, from)) {
            to = dateFns.addDays(to, 1);
        }
        // today < to
        if (dateFns.isBefore(today, to)) {
            time_section = '2';
        }
    }
    // 当日時間帯区分1
    if (
        from_1 &&
        from_1 !== '' &&
        to_1 &&
        to_1 !== ''
    ) {
        // from, to の日付データ
        const from = dateFns.parse(
            from_1 + ':00',
            'HH:mm:ss',
            today
        );
        let to = dateFns.parse(
            to_1 + ':00',
            'HH:mm:ss',
            today
        );
        // to が from より前の場合、翌日にする
        if (dateFns.isBefore(to, from)) {
            to = dateFns.addDays(to, 1);
        }
        // today < to
        if (dateFns.isBefore(today, to)) {
            time_section = '1';
        }
    }
    // 前日時間帯区分4
    if (
        from_4 &&
        from_4 !== '' &&
        to_4 &&
        to_4 !== ''
    ) {
        // from, to の日付データ
        const from = dateFns.parse(
            from_4 + ':00',
            'HH:mm:ss',
            yesterday
        );
        let to = dateFns.parse(
            to_4 + ':00',
            'HH:mm:ss',
            yesterday
        );
        // to が from より前の場合、翌日にする
        if (dateFns.isBefore(to, from)) {
            to = dateFns.addDays(to, 1);
        }
        // today < to
        if (dateFns.isBefore(today, to)) {
            time_section = '4';
            provide_date = dateFns.format(yesterday, 'yyyyMMdd');
        }
    }
    // 前日時間帯区分3
    if (
        from_3 &&
        from_3 !== '' &&
        to_3 &&
        to_3 !== ''
    ) {
        // from, to の日付データ
        const from = dateFns.parse(
            from_3 + ':00',
            'HH:mm:ss',
            yesterday
        );
        let to = dateFns.parse(
            to_3 + ':00',
            'HH:mm:ss',
            yesterday
        );
        // to が from より前の場合、翌日にする
        if (dateFns.isBefore(to, from)) {
            to = dateFns.addDays(to, 1);
        }
        // today < to
        if (dateFns.isBefore(today, to)) {
            time_section = '3';
            provide_date = dateFns.format(yesterday, 'yyyyMMdd');
        }
    }
    // 前日時間帯区分2
    if (
        from_2 &&
        from_2 !== '' &&
        to_2 &&
        to_2 !== ''
    ) {
        // from, to の日付データ
        const from = dateFns.parse(
            from_2 + ':00',
            'HH:mm:ss',
            yesterday
        );
        let to = dateFns.parse(
            to_2 + ':00',
            'HH:mm:ss',
            yesterday
        );
        // to が from より前の場合、翌日にする
        if (dateFns.isBefore(to, from)) {
            to = dateFns.addDays(to, 1);
        }
        // today < to
        if (dateFns.isBefore(today, to)) {
            time_section = '2';
            provide_date = dateFns.format(yesterday, 'yyyyMMdd');
        }
    }
    // 前日時間帯区分1
    if (
        from_1 &&
        from_1 !== '' &&
        to_1 &&
        to_1 !== ''
    ) {
        // from, to の日付データ
        const from = dateFns.parse(
            from_1 + ':00',
            'HH:mm:ss',
            yesterday
        );
        let to = dateFns.parse(
            to_1 + ':00',
            'HH:mm:ss',
            yesterday
        );
        // to が from より前の場合、翌日にする
        if (dateFns.isBefore(to, from)) {
            to = dateFns.addDays(to, 1);
        }
        // today < to
        if (dateFns.isBefore(today, to)) {
            time_section = '1';
            provide_date = dateFns.format(yesterday, 'yyyyMMdd');
        }
    }

    return {
        provide_date: provide_date,
        time_section: time_section,
    };
};

/**
 * 性別、年齢、身体活動レベルに応じて、指定した食堂メニューの合計栄養価、摂取基準と比較した割合をグラフデータとして返す。
 * 1食分の引数にtrueを指定した場合は、摂取基準を1/3として算出する。
 * @param {number} sex
 * @param {number} age
 * @param {number} life_activity_intensity
 * @param {boolean} is_one_serving
 * @param {Array} select_cafeteria_menu
 * @param {boolean} is_history
 * @returns 
 */
export const calcCafeteriaMenu = (sex, age, life_activity_intensity, is_one_serving, select_cafeteria_menu, is_history = false) => {
    if (![1, 2].includes(sex)) {
        sex = 1;
    }
    switch (true) {
        case (age >= 65):
            age = 65;
            break;
        case (age >= 50):
            age = 50;
            break;
        case (age >= 30):
            age = 30;
            break;
        case (age >= 18):
            age = 18;
            break;
        default:
            age = 18;
    }
    if (![1, 2, 3].includes(life_activity_intensity)) {
        life_activity_intensity = 1;
    }
    let select_data = {
        calories: 0,
        protein: 0,
        lipid: 0,
        carbohydrate: 0,
        sodium_content: 0,
        potassium: 0,
        dietary_fiber: 0,
        iron: 0,
    };
    let target_data = {
        calories: 100,
        protein: 100,
        lipid: 100,
        carbohydrate: 100,
        sodium_content: 100,
        potassium: 100,
        dietary_fiber: 100,
        iron: 100,
    };
    for (const m of select_cafeteria_menu) {
        if (is_history) {
            select_data.calories = select_data.calories + Number(m.calories);
            select_data.protein = select_data.protein + Number(m.protein);
            select_data.lipid = select_data.lipid + Number(m.lipid);
            select_data.carbohydrate = select_data.carbohydrate + Number(m.carbohydrate);
            select_data.sodium_content = select_data.sodium_content + Number(m.sodium_content);
            select_data.potassium = select_data.potassium + Number(m.potassium);
            select_data.dietary_fiber = select_data.dietary_fiber + Number(m.dietary_fiber);
            select_data.iron = select_data.iron + Number(m.iron);
        } else {
            select_data.calories = select_data.calories + Number(m.acf.calories);
            select_data.protein = select_data.protein + Number(m.acf.protein);
            select_data.lipid = select_data.lipid + Number(m.acf.lipid);
            select_data.carbohydrate = select_data.carbohydrate + Number(m.acf.carbohydrate);
            select_data.sodium_content = select_data.sodium_content + Number(m.acf.sodium_content);
            select_data.potassium = select_data.potassium + Number(m.acf.potassium);
            select_data.dietary_fiber = select_data.dietary_fiber + Number(m.acf.dietary_fiber);
            select_data.iron = select_data.iron + Number(m.acf.iron);
        }
    }
    if (is_one_serving) {
        select_data.calories = (select_data.calories / (CON_TARGET_DATA[sex][age][life_activity_intensity].calories / 3)) * 100;
        select_data.protein = (select_data.protein / (CON_TARGET_DATA[sex][age][life_activity_intensity].protein / 3)) * 100;
        select_data.lipid = (select_data.lipid / (CON_TARGET_DATA[sex][age][life_activity_intensity].lipid[1] / 3)) * 100;
        select_data.carbohydrate = (select_data.carbohydrate / (CON_TARGET_DATA[sex][age][life_activity_intensity].carbohydrate / 3)) * 100;
        select_data.sodium_content = (select_data.sodium_content / (CON_TARGET_DATA[sex][age][life_activity_intensity].sodium_content / 3)) * 100;
        select_data.potassium = (select_data.potassium / (CON_TARGET_DATA[sex][age][life_activity_intensity].potassium / 3)) * 100;
        select_data.dietary_fiber = (select_data.dietary_fiber / (CON_TARGET_DATA[sex][age][life_activity_intensity].dietary_fiber / 3)) * 100;
        select_data.iron = (select_data.iron / (CON_TARGET_DATA[sex][age][life_activity_intensity].iron / 3)) * 100;
    } else {
        select_data.calories = (select_data.calories / CON_TARGET_DATA[sex][age][life_activity_intensity].calories) * 100;
        select_data.protein = (select_data.protein / CON_TARGET_DATA[sex][age][life_activity_intensity].protein) * 100;
        select_data.lipid = (select_data.lipid / CON_TARGET_DATA[sex][age][life_activity_intensity].lipid[1]) * 100;
        select_data.carbohydrate = (select_data.carbohydrate / CON_TARGET_DATA[sex][age][life_activity_intensity].carbohydrate) * 100;
        select_data.sodium_content = (select_data.sodium_content / CON_TARGET_DATA[sex][age][life_activity_intensity].sodium_content) * 100;
        select_data.potassium = (select_data.potassium / CON_TARGET_DATA[sex][age][life_activity_intensity].potassium) * 100;
        select_data.dietary_fiber = (select_data.dietary_fiber / CON_TARGET_DATA[sex][age][life_activity_intensity].dietary_fiber) * 100;
        select_data.iron = (select_data.iron / CON_TARGET_DATA[sex][age][life_activity_intensity].iron) * 100;
    }
    return [
        {
            subject: 'エネルギー',
            select: select_data.calories,
            target: target_data.calories,
        },
        {
            subject: 'たんぱく質',
            select: select_data.protein,
            target: target_data.protein,
        },
        {
            subject: '脂質',
            select: select_data.lipid,
            target: target_data.lipid,
        },
        {
            subject: '炭水化物',
            select: select_data.carbohydrate,
            target: target_data.carbohydrate,
        },
        {
            subject: '食塩相当量',
            select: select_data.sodium_content,
            target: target_data.sodium_content,
        },
        {
            subject: 'カリウム',
            select: select_data.potassium,
            target: target_data.potassium,
        },
        {
            subject: '食物繊維',
            select: select_data.dietary_fiber,
            target: target_data.dietary_fiber,
        },
        {
            subject: '鉄',
            select: select_data.iron,
            target: target_data.iron,
        },
    ];
};

/**
 * 指定した食堂メニューの合計栄養価と摂取基準栄養価を返す
 * @param {number} sex
 * @param {number} age
 * @param {number} life_activity_intensity
 * @param {boolean} is_one_serving
 * @param {Array} select_cafeteria_menu
 * @param {boolean} is_history
 * @returns
 */
export const calcNutrition = (sex, age, life_activity_intensity, is_one_serving, select_cafeteria_menu, is_history = false) => {
    if (![1, 2].includes(sex)) {
        sex = 1;
    }
    switch (true) {
        case (age >= 65):
            age = 65;
            break;
        case (age >= 50):
            age = 50;
            break;
        case (age >= 30):
            age = 30;
            break;
        case (age >= 18):
            age = 18;
            break;
        default:
            age = 18;
    }
    if (![1, 2, 3].includes(life_activity_intensity)) {
        life_activity_intensity = 1;
    }
    const target_data = {
        calories: is_one_serving ? CON_TARGET_DATA[sex][age][life_activity_intensity].calories / 3 : CON_TARGET_DATA[sex][age][life_activity_intensity].calories,
        protein: is_one_serving ? CON_TARGET_DATA[sex][age][life_activity_intensity].protein / 3 : CON_TARGET_DATA[sex][age][life_activity_intensity].protein,
        lipid: is_one_serving ? 
            [
                CON_TARGET_DATA[sex][age][life_activity_intensity].lipid[0] / 3,
                CON_TARGET_DATA[sex][age][life_activity_intensity].lipid[1] / 3,
             ] : 
             [
                CON_TARGET_DATA[sex][age][life_activity_intensity].lipid[0],
                CON_TARGET_DATA[sex][age][life_activity_intensity].lipid[1],
             ],
        carbohydrate: is_one_serving ? CON_TARGET_DATA[sex][age][life_activity_intensity].carbohydrate / 3 : CON_TARGET_DATA[sex][age][life_activity_intensity].carbohydrate,
        sodium_content: is_one_serving ? CON_TARGET_DATA[sex][age][life_activity_intensity].sodium_content / 3 : CON_TARGET_DATA[sex][age][life_activity_intensity].sodium_content,
        potassium: is_one_serving ? CON_TARGET_DATA[sex][age][life_activity_intensity].potassium / 3 : CON_TARGET_DATA[sex][age][life_activity_intensity].potassium,
        dietary_fiber: is_one_serving ? CON_TARGET_DATA[sex][age][life_activity_intensity].dietary_fiber / 3 : CON_TARGET_DATA[sex][age][life_activity_intensity].dietary_fiber,
        iron: is_one_serving ? CON_TARGET_DATA[sex][age][life_activity_intensity].iron / 3 : CON_TARGET_DATA[sex][age][life_activity_intensity].iron,
    };
    let select_data = {
        calories: 0,
        protein: 0,
        lipid: 0,
        carbohydrate: 0,
        sodium_content: 0,
        potassium: 0,
        dietary_fiber: 0,
        iron: 0,
    };
    let cell_style = {
        calories: '',
        protein: '',
        lipid: '',
        carbohydrate: '',
        sodium_content: '',
        potassium: '',
        dietary_fiber: '',
        iron: '',
    }
    for (const m of select_cafeteria_menu) {
        if (is_history) {
            select_data.calories = select_data.calories + Number(m.calories);
            select_data.protein = select_data.protein + Number(m.protein);
            select_data.lipid = select_data.lipid + Number(m.lipid);
            select_data.carbohydrate = select_data.carbohydrate + Number(m.carbohydrate);
            select_data.sodium_content = select_data.sodium_content + Number(m.sodium_content);
            select_data.potassium = select_data.potassium + Number(m.potassium);
            select_data.dietary_fiber = select_data.dietary_fiber + Number(m.dietary_fiber);
            select_data.iron = select_data.iron + Number(m.iron);
        } else {
            select_data.calories = select_data.calories + Number(m.acf.calories);
            select_data.protein = select_data.protein + Number(m.acf.protein);
            select_data.lipid = select_data.lipid + Number(m.acf.lipid);
            select_data.carbohydrate = select_data.carbohydrate + Number(m.acf.carbohydrate);
            select_data.sodium_content = select_data.sodium_content + Number(m.acf.sodium_content);
            select_data.potassium = select_data.potassium + Number(m.acf.potassium);
            select_data.dietary_fiber = select_data.dietary_fiber + Number(m.acf.dietary_fiber);
            select_data.iron = select_data.iron + Number(m.acf.iron);
        }
    }
    const over_ratio = 1.2;
    const less_ratio = 0.8;
    if (target_data.calories * over_ratio < select_data.calories) {
        cell_style.calories = 'over-ratio';
    } else if (target_data.calories * less_ratio > select_data.calories) {
        cell_style.calories = is_one_serving ? 'less-ratio' : '';
    }
    if (target_data.protein * over_ratio < select_data.protein) {
        cell_style.protein = 'over-ratio';
    } else if (target_data.protein * less_ratio > select_data.protein) {
        cell_style.protein = is_one_serving ? 'less-ratio' : '';
    }
    if (target_data.lipid[1] * over_ratio < select_data.lipid) {
        cell_style.lipid = 'over-ratio';
    } else if (target_data.lipid[0] * less_ratio > select_data.lipid) {
        cell_style.lipid = is_one_serving ? 'less-ratio' : '';
    }
    if (target_data.carbohydrate * over_ratio < select_data.carbohydrate) {
        cell_style.carbohydrate = 'over-ratio';
    } else if (target_data.carbohydrate * less_ratio > select_data.carbohydrate) {
        cell_style.carbohydrate = is_one_serving ? 'less-ratio' : '';
    }
    if (target_data.sodium_content * over_ratio < select_data.sodium_content) {
        cell_style.sodium_content = 'over-ratio';
    } else if (target_data.sodium_content * less_ratio > select_data.sodium_content) {
        cell_style.sodium_content = is_one_serving ? 'less-ratio' : '';
    }
    if (target_data.potassium * over_ratio < select_data.potassium) {
        cell_style.potassium = 'over-ratio';
    } else if (target_data.potassium * less_ratio > select_data.potassium) {
        cell_style.potassium = is_one_serving ? 'less-ratio' : '';
    }
    if (target_data.dietary_fiber * over_ratio < select_data.dietary_fiber) {
        cell_style.dietary_fiber = 'over-ratio';
    } else if (target_data.dietary_fiber * less_ratio > select_data.dietary_fiber) {
        cell_style.dietary_fiber = is_one_serving ? 'less-ratio' : '';
    }
    if (target_data.iron * over_ratio < select_data.iron) {
        cell_style.iron = 'over-ratio';
    } else if (target_data.iron * less_ratio > select_data.iron) {
        cell_style.iron = is_one_serving ? 'less-ratio' : '';
    }
    return {
        select: select_data,
        target: target_data,
        cell: cell_style,
    };
};